<template>
    <div class="modal" v-if="visible">
        <div class="modal-bg"></div>
        <div class="modal-content" :style="{width:width}">
            <div class="modal-header">
                <div class="modal-title fl" v-if="showHeaderToggle">
                    <span class="modal-title-item" v-for="(item,index) in headerTitArr" :key="index" :class="titleIndex == index ? 'curr' : ''" @click="selectTitle(index)">{{item.name}}</span>
                </div>
                <span v-else class="fl">{{title}}</span>
                <i class="iconfont icon-danchuangguanbi fs12 cp color-grey" v-if="showClickCancel" @click="cancel"></i>
            </div>
            <div class="modal-warp">
                <slot></slot>
            </div>
            <div class="modal-footer ac" v-show="modalFoot">
                <button class="btn btn-sussess" @click="confirm">{{confirmText}}</button>
                <button class="btn btn-primary-border" v-if="showCancel" @click="cancel">{{cancelText}}</button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "modal",
    props: {
        titleIndex:{
            type:Number,
            default:0
        },
        visible:{
            type:Boolean,
            default:false
        },
        showHeaderToggle:{
            type:Boolean,
            default:true
        },
        modalFoot:{
            type:Boolean,
            default:true
        },
        width:{
            type:String,
            default:'400px'
        },
        title:{
            type:String,
            default:'提示'
        },
        confirmText:{
            type:String,
            default:'确定'
        },
        showCancel:{
            type:Boolean,
            default:true
        },
        showClickCancel:{
            type:Boolean,
            default:true
        },
        cancelText:{
            type:String,
            default:'取消'
        },
        questInfo:{
            type:Boolean,
            default:true
        },
        headerTitArr:{
            type:Array,
            default:function() {
                return [{name:'账号搜索',value:'账号搜索'},{name:'批量上传',value:'批量上传'}]
            }
        }
    },
    data() {
        return {

        }
    },
    watch:{
        // visible:{
        //     handler(n,o){
        //         if(n){
        //             if(document.getElementById('content')){
        //                 document.getElementById('content').style.zIndex = '1008';
        //             }
        //             if(document.getElementById('leftMune')){
        //                 document.getElementById('leftMune').style.zIndex = '1'
        //                 document.getElementById('leftMune').style.transition = '0s'
        //             }
        //             document.getElementById('tools').style.zIndex = '0'
        //         }else{ 
        //             if(document.getElementById('content')){
        //                 document.getElementById('content').style.zIndex = '1000';
        //             } 
        //             if(document.getElementById('leftMune')){
        //                 document.getElementById('leftMune').style.zIndex = '11'
        //                 document.getElementById('leftMune').style.transition = '0.5s'
        //             }
        //             document.getElementById('tools').style.zIndex = '1001'
        //         }
        //     }
        // }
    },
    mounted() {
       
    },
    created() {
		
    },
    methods: {
        selectTitle(val) { 
            this.$emit('sendSelectTitle',val)
        },
        confirm (){
            this.$emit('confirm')
        },
        cancel (){
            this.$emit('update:visible', false);
        }
	}
}
</script>
<style scoped>
    .modal{display:flex;align-items:center;justify-content:center;position:fixed;top:0;left:0;width:100%;height:100%;z-index:2000;animation:fadeIn .2s linear;}
    .modal-bg{width:100%;height:100%;background:rgba(0,0,0,.5);}
    .modal-content{position:absolute;background:#fff;border-radius:4px;}
    .modal-header{height:45px;padding:0 16px;line-height:44px;display:flex;justify-content:space-between;border-bottom:1px solid #ddd;}
    .modal-header .close{width:20px;height:20px;margin:11px 0;}
    .modal-header .close img{margin:4px;}
    .modal-title .modal-title-item{margin-right:10px;position:relative;cursor:pointer;}
    .modal-title .modal-title-item.curr{color:#287dff;}
    .modal-title .modal-title-item.curr:after{content:'';position:absolute;left:0;bottom:-15px;background:#ff9d0a;width:100%;height:2px;}
    .modal-warp{padding:24px;}
    .modal-footer{padding:8px 0 24px;}
    .modal-footer .btn{min-width:92px;margin:0 8px;}
</style>



// WEBPACK FOOTER //
// src/components/dialog2.vue